import Swiper from 'swiper';
import { onDomReady } from '../../JavaScript/on-dom-ready';

const handleGallerySlideChange = (swiper: Swiper) => {
  const sliderGallery = swiper.el.closest('.slider--gallery');
  if (sliderGallery === null) {
    return;
  }
  for (const thumbContainer of sliderGallery.getElementsByClassName(
    'gallery-thumbs',
  )) {
    const thumbs = thumbContainer.getElementsByClassName(
      'gallery-thumbs__thumb',
    );
    thumbs[swiper.previousIndex]?.classList.remove('active');
    thumbs[swiper.activeIndex]?.classList.add('active');
  }
};

onDomReady(() => {
  for (const sliderGallery of document.getElementsByClassName(
    'slider--gallery',
  )) {
    const swiperElement = sliderGallery.getElementsByClassName('swiper')[0];
    if (!(swiperElement instanceof HTMLElement)) {
      continue;
    }

    const gallerySwiper = new Swiper(swiperElement, {});
    gallerySwiper.on('slideChange', handleGallerySlideChange);

    for (const thumbContainer of sliderGallery.getElementsByClassName(
      'gallery-thumbs',
    )) {
      const thumbs = thumbContainer.getElementsByClassName(
        'gallery-thumbs__thumb',
      );
      for (let index = 0; index < thumbs.length; index++) {
        thumbs[index]!!.addEventListener('click', () =>
          gallerySwiper.slideTo(index),
        );
      }
    }
  }
});
